import { useLazyQuery, useMutation } from "@apollo/client";
import {
  Button,
  Divider,
  Form,
  Image,
  Input,
  Modal,
  ModalProps,
  Select,
  Spin,
  Switch,
  TimePicker,
  message,
} from "antd";
import * as React from "react";
import { Tabs } from "antd";
import "./index.css";
import { GET_DEVICE_LIVE_DATA } from "../../../graphql/devices";
import moment from "moment";
import "moment/locale/vi";
import TextArea from "antd/lib/input/TextArea";
import DetailIncidents from "./components/incidents";
import {
  DeviceState,
  GET_LIGHTBOX,
  NET_GEN,
  NET_PROVIDER,
} from "../../../graphql/lightboxs";
import * as control from "../../../graphql/lightbox-control";
import { formatTime } from "../../../utils/helpers";
import {
  ExclamationCircleOutlined,
  ReloadOutlined,
  SyncOutlined,
  ToolFilled,
} from "@ant-design/icons";
import confirm from "antd/lib/modal/confirm";
import DetailCharts from "./components/charts";
import ControlHistory from "./components/controlHistory";
import LightManagement from "./components/lights";
import { AuthContext } from "../../../context/AuthContext";

interface IDeviceDetailModalProps extends ModalProps {
  onCancel: () => void;
  lightboxId?: number;
  visible: boolean;
}

const DEFAULT_TAB_KEY = "2";

const DeviceDetailModal: React.FunctionComponent<IDeviceDetailModalProps> = ({
  visible,
  lightboxId,
  onCancel,
  ...props
}: IDeviceDetailModalProps) => {
  // const [form1] = Form.useForm();
  const { userInfo } = React.useContext(AuthContext);
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const [form4] = Form.useForm();
  const timeFormat = "HH:mm";
  const [tabKey, setTabKey] = React.useState(DEFAULT_TAB_KEY);
  const [lightbox, setLightbox] = React.useState<any>(undefined);
  const [googleMapLink, setGoogleMapLink] = React.useState<any>(
    "https://maps.google.com"
  );
  const [allowSetting, setAllowSetting] = React.useState(false);
  const [validLocation, setValidLocation] = React.useState(false);
  const [state, setState] = React.useState<DeviceState>(DeviceState.NORMAL);
  const [errors, setErrors] = React.useState({
    notconnect: false,
    plc: false,
    pm: false,
    lc: false,
  });

  const [resetMutation] = useMutation(control.LB_RESET_MUTATION);
  const [setCtTypeMutation] = useMutation(control.LB_CT_TYPE_MUTATION);
  const [disbr1Mutation] = useMutation(control.LB_DISBR1_MUTATION);
  const [disbr2Mutation] = useMutation(control.LB_DISBR2_MUTATION);
  const [setTimeslotMutation] = useMutation(control.LB_TIMESLOT_MUTATION);
  const [syncTimeMutation] = useMutation(control.LB_SYNCTIME_MUTATION);
  const [forceOnMutation] = useMutation(control.LB_FORCEON_MUTATION);
  const [forceTimerMutation] = useMutation(control.LB_FORCE_TIMER_MUTATION);
  const [manualTimerMutation] = useMutation(control.LB_MANUAL_TIMER_MUTATION);
  // const [setHpsDimMutation] = useMutation(control.LB_HPS_DIM_MUTATION);
  const [syncLocationMutation] = useMutation(control.LB_SYNC_LOCATION);
  const [setPmKindMutation] = useMutation(control.LB_BULK_PMKIND_MUTATION);

  const [getLiveData, { loading: liveDataLoading, startPolling, stopPolling }] =
    useLazyQuery<any, any>(GET_DEVICE_LIVE_DATA, {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
      onCompleted(data) {
        if (allowSetting) return;
        const d = data.device.liveData;
        setLightbox({
          ...lightbox,
          ...data,
        });
        setState(data.device.currentState);
        setErrors({
          notconnect: !d.isConnected,
          plc: d.plc_connect !== 1,
          pm: d.pm_connect !== 1,
          lc: d.lc_connect !== 1,
        });
        // form1.setFieldsValue({
        //   ...d,
        //   boxId: lightbox.boxId,
        //   clientId: lightbox.device.id,
        //   address: lightbox.address,
        //   province: lightbox.province.displayName,
        //   district: lightbox.district.displayName,
        //   raw_data: d.rawData.status,
        //   isConnected: d.isConnected,
        //   pmkind: d.pmkind,
        // });
        form2.setFieldsValue({
          ...d,
          rtc_time: moment(d.rtc_time)
            .utcOffset(7, false)
            .locale("vi")
            .format("HH:mm - dddd, DD MMMM YYYY"),
          allow_br1: !d.disbr1,
          allow_br2: !d.disbr2,
          br1_ontime: formatTime(d.br1_ontime),
          br1_offtime: formatTime(d.br1_offtime),
          br2_ontime: formatTime(d.br2_ontime),
          br2_offtime: formatTime(d.br2_offtime),
          // hps_ontime: formatTime(d.hps_ontime),
          // hps_offtime: formatTime(d.hps_offtime),
          raw_data: d.rawData.plc,
        });
        form3.setFieldsValue({
          ...d,
          raw_data: d.rawData.pmlc,
        });
        const token = localStorage.getItem("accessToken");
        let image_src = "error";
        if (lightbox.registerLog && lightbox.registerLog.imageUrl) {
          image_src = lightbox.registerLog.imageUrl.replace(
            "registeredimage",
            "registeredimagewithtoken"
          );
          image_src += `&token=${token}`;
        }
        form4.setFieldsValue({
          ...d,
          id: lightbox.id,
          modem_rtc: moment(d.modem_rtc)
            .utcOffset(7, false)
            .locale("vi")
            .format("HH:mm - dddd, DD MMMM YYYY"),
          boxId: lightbox.boxId,
          clientId: lightbox.device.id,
          address: lightbox.address,
          province: lightbox.province.displayName,
          district: lightbox.district.displayName,
          isConnected: d.isConnected ? "Có kết nối" : "Mất kết nối",
          version: `${d.fw_version} , ${d.hw_version}`,
          gps_coor: `${d.lat} , ${d.lng}`,
          sim_info: `${d.imei} / ${NET_PROVIDER[d.net_provider]} / ${
            NET_GEN[d.net_gen]
          } / ${d.rssi}`,
          raw_data: d.rawData.params,
          pmkind: d.pmkind,
          dataDns: data.device.dataDns,
          image_src,
        });
        setValidLocation(!!d.lat && !!d.lng);
        setGoogleMapLink(`https://maps.google.com/?q=${d.lat},${d.lng}`);
      },
    });

  const [getLightBoxInfo, { loading: lightboxLoading }] = useLazyQuery<
    any,
    any
  >(GET_LIGHTBOX, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      setLightbox(data.lightbox);
      if (data.lightbox.device) {
        getLiveData({
          variables: {
            id: data.lightbox.device.id,
          },
        });
        startPolling(10000);
      }
    },
  });

  React.useEffect(() => {
    if (visible && lightboxId) {
      setTabKey(DEFAULT_TAB_KEY);
      getLightBoxInfo({
        variables: {
          id: lightboxId,
        },
      });
    } else {
      stopPolling();
      setAllowSetting(false);
    }
  }, [visible, lightboxId]);

  const handleResetPLC = () => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: `Khởi động lại tủ ${lightbox.name}???`,
      onOk() {
        resetMutation({
          variables: {
            id: lightbox.device.id,
          },
        })
          .then(() => {
            message.success("Khởi động thành công!");
          })
          .catch((err) => message.error(err));
      },
      onCancel() {},
    });
  };

  const handleSyncTimePLC = () => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: `Đồng bộ thời gian cho tủ ${lightbox.name}???`,
      onOk() {
        syncTimeMutation({
          variables: {
            id: lightbox.device.id,
          },
        })
          .then(() => {
            message.success("Đồng bộ thành công!");
          })
          .catch((err) => message.error(err));
      },
      onCancel() {},
    });
  };

  const handleSyncLocation = () => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: `Đồng bộ tọa độ cho tủ ${lightbox.name}???`,
      onOk() {
        syncLocationMutation({
          variables: {
            id: lightbox.id,
          },
        })
          .then(() => {
            message.success("Đồng bộ thành công!");
          })
          .catch((err) => message.error(err));
      },
      onCancel() {},
    });
  };

  const handleSetPmKind = (pmkind: number) => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: `Thay đổi loại đồng hồ cho tủ ${lightbox.name}???`,
      onOk() {
        setPmKindMutation({
          variables: {
            ids: [lightbox.id],
            pmkind,
          },
        })
          .then(() => {
            message.success("Đồng bộ thành công!");
          })
          .catch((err) => message.error(err));
      },
      onCancel() {},
    });
  };

  const onFinishControl = (v: any) => {
    const liveData = lightbox.device.liveData;
    const id = lightbox.device.id;
    setAllowSetting(false);
    if (liveData.disbr1 !== !v.allow_br1) {
      disbr1Mutation({
        variables: {
          id,
          state: !v.allow_br1,
        },
      });
    }

    if (liveData.disbr2 !== !v.allow_br2) {
      disbr2Mutation({
        variables: {
          id,
          state: !v.allow_br2,
        },
      });
    }

    if (liveData.ct_type !== v.ct_type) {
      setCtTypeMutation({
        variables: {
          id,
          ctType: parseInt(v.ct_type),
        },
      });
    }

    const br1_on = v.br1_ontime.format("HHmm");
    const br1_off = v.br1_offtime.format("HHmm");
    const br2_on = v.br2_ontime.format("HHmm");
    const br2_off = v.br2_offtime.format("HHmm");
    // const hps_on = v.hps_ontime.format("HHmm");
    // const hps_off = v.hps_offtime.format("HHmm");

    if (
      liveData.br1_ontime !== br1_on ||
      liveData.br1_offtime !== br1_off ||
      liveData.br2_ontime !== br2_on ||
      liveData.br2_offtime !== br2_off
    ) {
      setTimeslotMutation({
        variables: {
          id,
          br1_on,
          br1_off,
          br2_on,
          br2_off,
        },
      });
    }

    // if (liveData.hps_ontime !== hps_on || liveData.hps_offtime !== hps_off) {
    //   setHpsDimMutation({
    //     variables: {
    //       id,
    //       onTime: hps_on,
    //       offTime: hps_off,
    //     },
    //   });
    // }

    if (liveData.force_state !== v.force_state) {
      forceOnMutation({
        variables: {
          id,
          state: v.force_state,
        },
      });
    }

    if (liveData.force_totaltime !== v.force_totaltime) {
      forceTimerMutation({
        variables: {
          id,
          data: parseInt(v.force_totaltime),
        },
      });
    }

    if (liveData.manual_totaltime !== v.manual_totaltime) {
      manualTimerMutation({
        variables: {
          id,
          data: parseInt(v.manual_totaltime),
        },
      });
    }
  };

  return (
    <>
      <Modal
        className="CustomModal !w-auto "
        title={
          lightboxLoading ? (
            <Spin tip="Đang tải" />
          ) : lightbox ? (
            <div
              className={`py-4 px-6 mx-[-24px] my-[-16px] overflow-auto ${
                state === DeviceState.ERROR
                  ? "bg-variant-error"
                  : state === DeviceState.LIGHT_ON
                    ? "bg-variant-success"
                    : "bg-neutral-l70"
              }`}
            >
              {lightbox.name}
            </div>
          ) : (
            "Chưa xác định"
          )
        }
        open={visible}
        destroyOnClose={true}
        maskClosable={false}
        centered
        footer={false}
        onCancel={onCancel}
      >
        <Tabs
          activeKey={tabKey}
          onChange={(key) => {
            setTabKey(key);
          }}
        >
          <Tabs.TabPane tab="Điều khiển" key="2">
            {(liveDataLoading || lightboxLoading) && (
              <Spin className="absolute flex w-full items-center justify-center h-[70%]" />
            )}
            <Form
              form={form2}
              name="basic"
              // labelCol={{ span: 6 }}
              wrapperCol={{ span: 24 }}
              className={`grid grid-cols-4 gap-2 mx-[-16px] md:mx-0 ${
                liveDataLoading || lightboxLoading ? "opacity-45" : ""
              }`}
              onFinish={onFinishControl}
              // onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              {/* Setting */}
              {userInfo?.isAdmin && (
                <>
                  <div className="flex items-center col-span-2">
                    Cho phép cài đặt/điều khiển:
                  </div>
                  <div className="flex items-center col-span-1">
                    <Switch
                      defaultChecked={false}
                      checked={allowSetting}
                      onChange={(checked) => setAllowSetting(checked)}
                    />
                  </div>
                  <div className="flex items-center col-span-1">
                    <Button
                      onClick={handleResetPLC}
                      disabled={!allowSetting}
                      icon={<ReloadOutlined />}
                    >
                      <div className="hidden md:inline-block ml-1">
                        Khởi động lại
                      </div>
                    </Button>
                  </div>
                </>
              )}
              {/* <div
                className="flex items-center col-span-1 w-fit"
                title="Khởi động lại"
              >
                <Button
                  onClick={handleResetPLC}
                  disabled={!allowSetting}
                  icon={<ReloadOutlined />}
                >
                  <div className="hidden md:inline-block ml-1">
                    Khởi động lại
                  </div>
                </Button>
              </div> */}
              {allowSetting && (
                <div className="flex items-center col-span-4 gap-2">
                  <Button
                    onClick={() => {
                      const d = lightbox.device.liveData;
                      form2.setFieldsValue({
                        ...d,
                        allow_br1: !d.disbr1,
                        allow_br2: !d.disbr2,
                        br1_ontime: formatTime(d.br1_ontime),
                        br1_offtime: formatTime(d.br1_offtime),
                        br2_ontime: formatTime(d.br1_ontime),
                        br2_offtime: formatTime(d.br1_ontime),
                        // hps_ontime: formatTime(d.hps_ontime),
                        // hps_offtime: formatTime(d.hps_offtime),
                      });
                    }}
                  >
                    Hủy
                  </Button>
                  <Button
                    className="bg-blue-primary text-variant-white"
                    htmlType="submit"
                  >
                    Xác nhận
                  </Button>
                </div>
              )}
              <Divider className="col-span-4" />
              {/* PLC time */}
              <div className="col-span-4 flex gap-2 items-end">
                <Form.Item
                  className="w-full"
                  label="Thời gian của tủ"
                  name="rtc_time"
                >
                  <Input disabled readOnly />
                </Form.Item>
                <Button
                  title="Đồng bộ thời gian cho tủ"
                  disabled={!allowSetting}
                  icon={<SyncOutlined />}
                  onClick={handleSyncTimePLC}
                ></Button>
              </div>

              {/* <div className="flex items-end w-fit col-span-1" title="Đồng bộ">
                <Button
                  onClick={handleSyncTimePLC}
                  disabled={!allowSetting}
                  icon={<SyncOutlined />}
                >
                  <div className="hidden md:inline-block ml-1">Đồng bộ</div>
                </Button>
              </div> */}
              <Divider className="col-span-4" />

              {/* Out, Branch Status */}
              <div className="flex items-center col-span-2">Ngõ ra PLC:</div>
              <Form.Item
                className="col-span-1"
                valuePropName="checked"
                name="out1_status"
              >
                {/* <Input className="w-full" readOnly /> */}
                <Switch checkedChildren="N1" unCheckedChildren="N1" disabled />
              </Form.Item>
              <Form.Item
                className="col-span-1"
                valuePropName="checked"
                name="out2_status"
              >
                <Switch checkedChildren="N2" unCheckedChildren="N2" disabled />
                {/* <Input className="w-full" prefix={<span className="font-bold">2</span>} readOnly /> */}
              </Form.Item>
              <div className="flex items-center col-span-2">
                Trạng thái nhánh đèn:
              </div>
              <Form.Item
                className="col-span-1"
                valuePropName="checked"
                name="br1_status"
              >
                <Switch checkedChildren="N1" unCheckedChildren="N1" disabled />
                {/* <Input className="w-full" readOnly /> */}
              </Form.Item>
              <Form.Item
                className="col-span-1"
                valuePropName="checked"
                name="br2_status"
              >
                <Switch checkedChildren="N2" unCheckedChildren="N2" disabled />
                {/* <Input className="w-full" readOnly /> */}
              </Form.Item>
              <div className="flex items-center col-span-2 gap-1">
                <ToolFilled className="text-xs mb-2 text-variant-warning" />
                <span>Cho phép hoạt động:</span>
              </div>
              <Form.Item
                className="col-span-1"
                valuePropName="checked"
                name="allow_br1"
              >
                <Switch
                  checkedChildren="N1"
                  unCheckedChildren="N1"
                  disabled={!allowSetting}
                />
                {/* <Input className="w-full" readOnly /> */}
              </Form.Item>
              <Form.Item
                className="col-span-1"
                valuePropName="checked"
                name="allow_br2"
              >
                <Switch
                  checkedChildren="N2"
                  unCheckedChildren="N2"
                  disabled={!allowSetting}
                />
                {/* <Input className="w-full" readOnly /> */}
              </Form.Item>
              <div className="flex items-center col-span-2 gap-1">
                <ToolFilled className="text-xs mb-2 text-variant-warning" />
                Thời gian mở Nhánh 1:
              </div>
              <Form.Item className="col-span-1" label="Từ" name="br1_ontime">
                {/* <Input className="w-full" readOnly /> */}
                <TimePicker format={timeFormat} disabled={!allowSetting} />
              </Form.Item>
              <Form.Item className="col-span-1" label="Đến" name="br1_offtime">
                {/* <Input className="w-full" readOnly /> */}
                <TimePicker format={timeFormat} disabled={!allowSetting} />
              </Form.Item>
              <div className="flex items-center col-span-2 gap-1">
                <ToolFilled className="text-xs mb-2 text-variant-warning" />
                Thời gian mở Nhánh 2:
              </div>
              <Form.Item className="col-span-1" label="Từ" name="br2_ontime">
                {/* <Input className="w-full" readOnly /> */}
                <TimePicker format={timeFormat} disabled={!allowSetting} />
              </Form.Item>
              <Form.Item className="col-span-1" label="Đến" name="br2_offtime">
                {/* <Input className="w-full" readOnly /> */}
                <TimePicker format={timeFormat} disabled={!allowSetting} />
              </Form.Item>
              {/* <div className="flex items-center col-span-2 gap-1">
                <ToolFilled className="text-xs mb-2 text-variant-warning" />
                Thời gian tiết giảm:
              </div>
              <Form.Item className="col-span-1" label="Từ" name="hps_ontime">
                <TimePicker format={timeFormat} disabled={!allowSetting} />
              </Form.Item>
              <Form.Item className="col-span-1" label="Đến" name="hps_offtime">
                <TimePicker format={timeFormat} disabled={!allowSetting} />
              </Form.Item> */}
              <Divider className="col-span-4" />

              {/* CT Type */}
              <div className="flex items-center col-span-2 gap-1">
                <ToolFilled className="text-xs mb-2 text-variant-warning" />
                Loại công suất tủ:
              </div>
              <Form.Item className="col-span-2" name="ct_type">
                {/* <Input className="w-full" readOnly /> */}
                <Select
                  // style={{ width: 272 }}
                  placeholder="Chọn công suất tủ"
                  // onChange={handleChange}
                  options={[
                    { value: 0, label: "Không xác định" },
                    { value: 1, label: "50A" },
                    { value: 2, label: "100A" },
                  ]}
                  disabled={!allowSetting}
                />
              </Form.Item>
              <div className="flex items-center col-span-2">
                Trạng thái cửa tủ:
              </div>
              <Form.Item
                className="col-span-2"
                valuePropName="checked"
                name="door_state"
              >
                <Switch
                  checkedChildren="Mở"
                  unCheckedChildren="Đóng"
                  disabled={true}
                />
              </Form.Item>
              <Divider className="col-span-4" />

              {/* Force State */}
              <div className="flex items-center col-span-2 gap-1">
                <ToolFilled className="text-xs mb-2 text-variant-warning" />
                Cưỡng chế bật tủ:
              </div>
              <Form.Item
                className="col-span-2"
                valuePropName="checked"
                name="force_state"
              >
                {/* <Input className="w-full" readOnly /> */}
                <Switch disabled={!allowSetting} />
              </Form.Item>
              <div className="flex items-center col-span-2 gap-1">
                <ToolFilled className="text-xs mb-2 text-variant-warning" />
                Thời gian bật:
              </div>
              <Form.Item className="col-span-2" name="force_totaltime">
                <Input
                  className="w-[136px]"
                  suffix={<span>giây</span>}
                  disabled={!allowSetting}
                />
              </Form.Item>
              <Form.Item
                className="col-span-2"
                label="Thời gian bật hiện tại"
                name="force_curtime"
              >
                <Input
                  className="w-[136px]"
                  disabled
                  suffix={<span>giây</span>}
                />
              </Form.Item>
              <Form.Item
                className="col-span-2"
                label="Thời gian bật còn lại"
                name="force_remaintime"
              >
                <Input
                  className="w-[136px]"
                  disabled
                  suffix={<span>giây</span>}
                />
              </Form.Item>
              <Divider className="col-span-4" />

              {/* Manual State */}
              <div className="flex items-center col-span-2">
                Trạng thái công tắc tay:
              </div>
              <Form.Item
                className="col-span-2"
                valuePropName="checked"
                name="manual_state"
              >
                {/* <Input className="w-full" readOnly /> */}
                <Switch disabled />
              </Form.Item>
              <div className="flex items-center col-span-2 gap-1">
                <ToolFilled className="text-xs mb-2 text-variant-warning" />
                Thời gian bật:
              </div>
              <Form.Item className="col-span-2" name="manual_totaltime">
                <Input
                  className="w-[136px]"
                  suffix={<span>giây</span>}
                  disabled={!allowSetting}
                />
              </Form.Item>
              <Form.Item
                className="col-span-2"
                label="Thời gian bật hiện tại"
                name="manual_curtime"
              >
                <Input
                  className="w-[136px]"
                  disabled
                  suffix={<span>giây</span>}
                />
              </Form.Item>
              <Form.Item
                className="col-span-2"
                label="Thời gian bật còn lại"
                name="manual_remaintime"
              >
                <Input
                  className="w-[136px]"
                  disabled
                  suffix={<span>giây</span>}
                />
              </Form.Item>
              {userInfo?.isSuperAdmin && (
                <>
                  <Divider className="col-span-4" />
                  <Form.Item
                    className="col-span-4"
                    label="Dữ liệu thô"
                    name="raw_data"
                  >
                    <TextArea disabled className="w-full" readOnly />
                  </Form.Item>
                </>
              )}
            </Form>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Giám sát" key="3">
            <Form
              form={form3}
              name="basic"
              wrapperCol={{ span: 24 }}
              className="grid grid-cols-12 gap-2 max-w-[600px]"
              autoComplete="off"
            >
              <Form.Item className="col-span-3" label="v1n" name="v1n">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="v2n" name="v2n">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="v3n" name="v3n">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="avg_v" name="avg_v">
                <Input className="w-full" readOnly />
              </Form.Item>

              <Form.Item className="col-span-3" label="v12" name="v12">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="v23" name="v23">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="v31" name="v31">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="avg_ll" name="avg_ll">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Divider className="col-span-12" />

              <Form.Item className="col-span-3" label="i1" name="i1">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="i2" name="i2">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="i3" name="i3">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="avg_i" name="avg_i">
                <Input className="w-full" readOnly />
              </Form.Item>

              <Form.Item className="col-span-4" label="i_leak" name="i_leak">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item
                className="col-span-4"
                label="ct_primary"
                name="ct_primary"
              >
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item
                className="col-span-4"
                label="ct_second"
                name="ct_second"
              >
                <Input className="w-full" readOnly />
              </Form.Item>
              <Divider className="col-span-12" />

              <Form.Item className="col-span-3" label="kw1" name="kw1">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="kw2" name="kw2">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="kw3" name="kw3">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item
                className="col-span-3"
                label="total_kW"
                name="total_kW"
              >
                <Input className="w-full" readOnly />
              </Form.Item>

              <Form.Item className="col-span-3" label="kVA1" name="kVA1">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="kVA2" name="kVA2">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="kVA3" name="kVA3">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item
                className="col-span-3"
                label="total_kVA"
                name="total_kVA"
              >
                <Input className="w-full" readOnly />
              </Form.Item>

              <Form.Item className="col-span-3" label="kVAr1" name="kVAr1">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="kVAr2" name="kVAr2">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="kVAr3" name="kVAr3">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item
                className="col-span-3"
                label="total_kVAr"
                name="total_kVAr"
              >
                <Input className="w-full" readOnly />
              </Form.Item>

              <Form.Item className="col-span-3" label="PF1" name="PF1">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="PF2" name="PF2">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="PF3" name="PF3">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="avg_PF" name="avg_PF">
                <Input className="w-full" readOnly />
              </Form.Item>

              <Form.Item className="col-span-6" label="freq" name="freq">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-6" label="kWh" name="kWh">
                <Input className="w-full" readOnly />
              </Form.Item>
              {userInfo?.isSuperAdmin && (
                <>
                  <Divider className="col-span-12" />
                  <Form.Item
                    className="col-span-12"
                    label="Dữ liệu thô"
                    name="raw_data"
                  >
                    <TextArea className="w-full" rows={8} readOnly />
                  </Form.Item>
                </>
              )}
            </Form>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Thông tin" key="4">
            <Form
              form={form4}
              name="basic"
              wrapperCol={{ span: 24 }}
              className="grid grid-cols-6 gap-2 max-w-[600px]"
              autoComplete="off"
            >
              <Form.Item className="col-span-2" label="ID" name="id">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-2" label="Mã tủ" name="boxId">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item
                className="col-span-2"
                label="Mã thiết bị"
                name="clientId"
              >
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-6" label="Địa chỉ" name="address">
                <Input className="w-full" readOnly />
              </Form.Item>

              <Form.Item
                className="col-span-3"
                label="Quận/Huyện"
                name="district"
              >
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="Tỉnh" name="province">
                <Input className="w-full" readOnly />
              </Form.Item>
              <Divider className="col-span-6" />
              <Form.Item
                className="col-span-3"
                label="Trạng thái mạng"
                name="isConnected"
              >
                <Input
                  className={`w-full ${
                    errors.notconnect && "bg-variant-error"
                  }`}
                  readOnly
                />
              </Form.Item>
              <div className="flex flex-col md:flex-row md:gap-1 justify-center col-span-3">
                <div className="flex gap-1 items-center h-8">
                  <ToolFilled className="text-xs mb-2 text-variant-warning" />
                  <span className="whitespace-nowrap">Loại PM</span>
                  <span className="hidden md:block">:</span>
                </div>
                <Form.Item name="pmkind" className="w-full">
                  {/* <Input className="w-full" readOnly /> */}
                  <Select
                    onSelect={(value) => {
                      handleSetPmKind(value);
                    }}
                    options={[
                      { value: 1, label: "1" },
                      { value: 2, label: "2" },
                    ]}
                  />
                </Form.Item>
              </div>
              <Form.Item className="col-span-2" label="PLC" name="plc_connect">
                <Input
                  className={`w-full ${errors.plc && "bg-variant-error"}`}
                  readOnly
                />
              </Form.Item>
              <Form.Item className="col-span-2" label="LC" name="lc_connect">
                <Input
                  className={`w-full ${errors.lc && "bg-variant-error"}`}
                  readOnly
                />
              </Form.Item>
              <Form.Item className="col-span-2" label="PM" name="pm_connect">
                <Input
                  className={`w-full ${errors.pm && "bg-variant-error"}`}
                  readOnly
                />
              </Form.Item>
              <Divider className="col-span-6" />
              <Form.Item
                className="col-span-3"
                label="Phiên bản (FW, HW)"
                name="version"
              >
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item className="col-span-3" label="Máy chủ" name="dataDns">
                <Input className="w-full" readOnly />
              </Form.Item>
              <div className="col-span-6 flex gap-2 items-end">
                <Form.Item
                  className="w-full"
                  label="Tọa độ GPS"
                  name="gps_coor"
                >
                  <Input className="w-full" readOnly />
                </Form.Item>
                <a
                  href={googleMapLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Mở Google Maps"
                >
                  <img src="/images/google-maps.png" alt="OpenGoogleMap" />
                </a>
                <Button
                  className="w-10"
                  title="Đồng bộ tọa độ cho tủ"
                  disabled={!validLocation}
                  icon={<SyncOutlined />}
                  onClick={handleSyncLocation}
                ></Button>
              </div>
              <Form.Item
                className="col-span-6"
                label="SIM (IMEI / Nhà Mạng / Dịch vụ / Cường độ)"
                name="sim_info"
              >
                <Input className="w-full" readOnly />
              </Form.Item>
              <div className="col-span-3">Hình ảnh:</div>
              <Form.Item
                className="col-span-3"
                valuePropName="src"
                name="image_src"
              >
                <Image
                  alt="Ảnh tủ"
                  width="100%"
                  fallback="data:image/png;base64,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"
                />
              </Form.Item>
              {/* <Form.Item
                className="col-span-6"
                label="Thời gian thực modem"
                name="modem_rtc"
              >
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item
                className="col-span-3"
                label="modem_timesrc"
                name="modem_timesrc"
              >
                <Input className="w-full" readOnly />
              </Form.Item>
              <Form.Item
                className="col-span-3"
                label="modem_updated"
                name="modem_updated"
              >
                <Input className="w-full" readOnly />
              </Form.Item> */}
              {userInfo?.isSuperAdmin && (
                <>
                  <Divider className="col-span-6" />
                  <Form.Item
                    className="col-span-6"
                    label="Dữ liệu thô"
                    name="raw_data"
                  >
                    <TextArea className="w-full" readOnly />
                  </Form.Item>
                </>
              )}
            </Form>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Sự cố" key="5">
            <DetailIncidents lightbox={lightbox} isOpen={visible} />
          </Tabs.TabPane>
          <Tabs.TabPane destroyInactiveTabPane tab="Biểu đồ" key="6">
            <DetailCharts
              deviceId={lightbox && lightbox.device ? lightbox.device.id : ""}
            />
          </Tabs.TabPane>
          <Tabs.TabPane destroyInactiveTabPane tab="Đèn" key="7">
            <LightManagement lightbox={lightbox} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Lịch sử điều khiển" key="8">
            <ControlHistory lightbox={lightbox} />
          </Tabs.TabPane>
        </Tabs>
      </Modal>
    </>
  );
};

export default DeviceDetailModal;
